import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "@/api";

const inputCls = "w-full border border-stone-300 px-3 py-2 text-sm focus:border-stone-900 focus:outline-none";

export default function AdminHome() {
  const [form, setForm] = useState({
    tagline: "", heroText: "", marqueeText: "", status_text: "NOW BOOKING",
    status_published: true, rates_note: "", inquiry_intro: "",
  });
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/content/home").then((r) => {
      setForm({
        tagline: r.data.tagline || "",
        heroText: (r.data.hero_lines || []).join("\n"),
        marqueeText: (r.data.marquee_items || []).join(", "),
        status_text: r.data.status_text || "NOW BOOKING",
        status_published: !!r.data.status_published,
        rates_note: r.data.rates_note || "",
        inquiry_intro: r.data.inquiry_intro || "",
      });
      setLoaded(true);
    }).catch((e) => toast.error(errMsg(e)));
  }, []);

  const save = async () => {
    try {
      await api.put("/admin/home", {
        tagline: form.tagline,
        hero_lines: form.heroText.split("\n").map((s) => s.trim()).filter(Boolean),
        marquee_items: form.marqueeText.split(",").map((s) => s.trim()).filter(Boolean),
        status_text: form.status_text,
        status_published: form.status_published,
        rates_note: form.rates_note,
        inquiry_intro: form.inquiry_intro,
      });
      toast.success("Homepage saved");
    } catch (e) { toast.error(errMsg(e)); }
  };

  if (!loaded) return <p className="text-xs text-stone-500">Loading…</p>;

  return (
    <div data-testid="admin-home" className="flex flex-col gap-4">
      <div>
        <label className="mb-1 block text-xs font-semibold text-stone-600">Hero lines (one per line, shown big on the homepage)</label>
        <textarea data-testid="home-hero" rows={3} className={inputCls} value={form.heroText} onChange={(e) => setForm({ ...form, heroText: e.target.value })} />
      </div>
      <div>
        <label className="mb-1 block text-xs font-semibold text-stone-600">Tagline</label>
        <textarea data-testid="home-tagline" rows={2} className={inputCls} value={form.tagline} onChange={(e) => setForm({ ...form, tagline: e.target.value })} />
      </div>
      <div>
        <label className="mb-1 block text-xs font-semibold text-stone-600">Marquee items (comma separated)</label>
        <input data-testid="home-marquee" className={inputCls} value={form.marqueeText} onChange={(e) => setForm({ ...form, marqueeText: e.target.value })} />
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        <div>
          <label className="mb-1 block text-xs font-semibold text-stone-600">Status tag text</label>
          <input data-testid="home-status-text" className={inputCls} value={form.status_text} onChange={(e) => setForm({ ...form, status_text: e.target.value })} />
        </div>
        <label className="mt-5 flex items-center gap-2 text-xs font-semibold text-stone-700">
          <input data-testid="home-status-published" type="checkbox" checked={form.status_published} onChange={(e) => setForm({ ...form, status_published: e.target.checked })} />
          Show "STATUS:" tag on the site
        </label>
      </div>
      <div>
        <label className="mb-1 block text-xs font-semibold text-stone-600">Rates page note</label>
        <textarea data-testid="home-rates-note" rows={2} className={inputCls} value={form.rates_note} onChange={(e) => setForm({ ...form, rates_note: e.target.value })} />
      </div>
      <div>
        <label className="mb-1 block text-xs font-semibold text-stone-600">Inquiry popup line ("you've got mail")</label>
        <input data-testid="home-inquiry-intro" className={inputCls} value={form.inquiry_intro} onChange={(e) => setForm({ ...form, inquiry_intro: e.target.value })} />
      </div>
      <button data-testid="home-save" onClick={save} className="self-start bg-stone-900 px-5 py-2 text-xs font-semibold text-white hover:bg-stone-700">
        Save homepage
      </button>
    </div>
  );
}
